var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"wrapper",style:(`width: ${_vm.size}rem; height: ${_vm.size}rem`)},[_c('KoderiaClose',{attrs:{"size":Number(_vm.size) * 0.5,"color":"white"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }